import { Button, Pencil, TriangleAlert, CircleX } from "@repo/ui";
import type { FieldData, FieldValue } from "../types";

type Props = {
  field: FieldData;
  displayValue: string;
  hasPendingChange: boolean;
  isMixed?: boolean;
  onEditClick: (fieldId: number, currentValue: FieldValue) => void;
  onClearClick: (fieldId: number) => void;
};

export const FieldValueDisplay = ({
  field,
  displayValue,
  hasPendingChange,
  isMixed,
  onEditClick,
  onClearClick,
}: Props) => {
  return (
    <div
      className={`group flex items-center gap-2 ${hasPendingChange ? "rounded-lg bg-yellow-50 px-2 py-1" : ""}`}
    >
      {isMixed ? (
        <span className="flex items-center gap-2">
          <span className="text-[12px] font-semibold">Multiple values</span>
          <TriangleAlert className="size-4" />
        </span>
      ) : (
        <span
          className={`flex-1 text-[12px] ${hasPendingChange ? "font-semibold text-yellow-800" : "text-gray-700"}`}
        >
          {displayValue || "-"}
        </span>
      )}
      {hasPendingChange && <span className="text-xs text-yellow-600 italic">(pending)</span>}
      {!field.required && (
        <Button
          onClick={() => onClearClick(field.id)}
          variant="ghost"
          className="pointer-events-none opacity-0 transition-opacity duration-150 group-hover:pointer-events-auto group-hover:opacity-100"
          size="icon_sm"
          icon={<CircleX className="h-4 w-4 text-red-600" />}
          title="Clear Field"
        />
      )}
      <Button
        onClick={() => onEditClick(field.id, displayValue)}
        variant="ghost"
        className="pointer-events-none opacity-0 transition-opacity duration-150 group-hover:pointer-events-auto group-hover:opacity-100"
        size="icon_sm"
        icon={<Pencil className="text-gxe-primary h-4 w-4" />}
        title="Edit"
      />
    </div>
  );
};
